/** Rutas públicas del sitio (sin prefijo /dental-clinic). */
export const paths = {
  home: '/',
  reservas: '/reservas',
  blog: '/blog',
  blogPost: (slug) => `/blog/${encodeURIComponent(String(slug || ''))}`,
  adminBlog: '/admin/blog',
  adminBlogEdit: (slug) =>
    `/admin/blog/edit/${encodeURIComponent(String(slug || ''))}`,
  adminPerson: '/admin-person',
  appointment: '/appointment',
  emergency: '/emergency-dentist-cusco',
  implants: '/dental-implants-cusco',
  team: '/team',
  userProfile: '/user/profile',
  userChat: '/user/chat_section',
  login: '/login_user',
  register: '/register',
  location: '/ubicacion-clinica-ortodoncia-cusco',
  libroReclamaciones: '/libro-de-reclamaciones',
};

/** Prefijo de rutas API (backend Node). */
export const apiPrefix = '/dental-clinic';
